export default __webpack_public_path__ + "static/media/social_email.dd68a1ac.svg";